export default "__VITE_ASSET__d73f094c__"